import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { Input, Tooltip, AutoComplete, Icon as AIcon } from 'antd';
import { EditIcon, CarIcon, Icon, BackIcon, FromToIcon, PlusIcon, CrownIcon, BriefcaseIcon, MarkerIcon, ForwardIcon, HomeIcon, DotIcon } from '../core/icons'
// import googleResponse from './googleResponse.json'
import {requestDirections, getCurrentPosition} from './actions'
import { change } from 'redux-form'
import { connect } from 'react-redux'
import {GoogleApiWrapper} from 'google-maps-react';
import { Link } from 'react-router-dom'
const Option = AutoComplete.Option;
const OptGroup = AutoComplete.OptGroup;


function renderTitle(title) {
  return (
    <span>
      {title}
      {/* <a
        style={{ float: 'right' }}
        href="/account/favorite-places"
      >
        manage / add
      </a> */}
    </span>
  );
}

const placesAsOptions = (data)=>
[<OptGroup
    key={'places'}
    label={
      <span>
        from your {' '}
        <Link to="/account/favorite-places">
          Favorite Places
        </Link>
        :
      </span>
    }
  >
  {
    data.length ? data.map((opt,i) => (
      <Option key={opt.token_id} value={opt.token_id} data={opt}
        // the native html title on hover
        title={`${opt.city} ${opt.state} ${opt.country} ${opt.postal_code}`}
        visibleValue={opt.name}
      >
        <Icon type={opt.icon_name}/>
        <div>
          <b>
            {opt.name}
          </b>
          <p>{opt.street}</p>
        </div>
    </Option>
    )) : []
  }
</OptGroup>]


const resultsAsOptions = (data)=>
[<OptGroup
    key={'results'}
    label={renderTitle('from Google results:')}
  >
  {
    data.map((opt,i) => (
      <Option key={opt.id} value={opt.id} data={opt} visibleValue={opt.description} title={opt.description}>
          <MarkerIcon/>
          <div>
            <b>
              {opt.structured_formatting.main_text}
            </b>
            <p>{opt.structured_formatting.secondary_text}</p>
          </div>
      </Option>
    ))
  }
</OptGroup>]


const customAsOption = (searchValue, allowCustomAddress)=> {
  return (allowCustomAddress) ? [
    <Option key={0} value={searchValue} data={{custom: true}} visibleValue={searchValue} title={searchValue}>
      <EditIcon/>
      <div>
        <b>
          "{searchValue}"
        </b>
        <p style={{'font-style': 'italic'}}>
          text only (no automatic calculations)
        </p>
      </div>
    </Option>
  ] : []
}

const CurrentLocation = (getCurrentPosition)=>
  <Option key={0} value={'curr loc'} data={{}} title={'curr loc'}>
    <DotIcon/>
    {'curr loc'}
  </Option>
  // <Option disabled key="all" className="show-all">
  //   <a onClick={getCurrentPosition}>
  //     Current location
  //   </a>
  // </Option>


class Complete extends React.Component {
  state = {
    dataSource: [
      // CurrentLocation(this.props.getCurrentPosition),
      ...placesAsOptions(this.props.places)
    ],
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.places !== this.props.places) {
      this.setState({
        dataSource: [
          // CurrentLocation(this.props.getCurrentPosition),
          ...placesAsOptions(this.props.places)
        ],
      })
    }
  }


  handleSearch = (value) => {
    if (value.trim().length>0) {
      // const AutocompleteService = new window.google.maps.places.AutocompleteService
      const {allowCustomAddress} = this.props
      const AutocompleteService = new this.props.google.maps.places.AutocompleteService
      AutocompleteService.getPlacePredictions({ input: value }, (response)=>{
        response && this.setState({
          dataSource: [
            ...customAsOption(value, allowCustomAddress),
            // TODO replace with filterOption ?
            ...placesAsOptions(this.props.places.filter(p=> RegExp(value, 'ig').test(p.name) )),
            // CurrentLocation(this.props.getCurrentPosition),

            ...resultsAsOptions(response)
          ],
        });
      })
    } else {
      this.setState({
        dataSource: [
          // CurrentLocation(this.props.getCurrentPosition),
          ...placesAsOptions(this.props.places)
        ],
      });
    }



  }

  render() {
    const { dataSource } = this.state;
    return (
      <div>
      <AutoComplete
        allowClear
        dataSource={dataSource}
        onSelect={this.props.onSelect}
        onSearch={this.handleSearch}
        optionLabelProp="visibleValue"
        placeholder="Search for address or business name"
        backfill
        {...this.props}
        defaultValue={this.props.defaultValue}
      >
        <Input style={this.props.isPlace
          ? {'font-style': 'italic','font-weight': 'bold'}
          :null}
        />
      </AutoComplete>
    </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  const {place, from, to} = ownProps
  const trip = state.form.trip.values
  const direction = from ? 'start' : 'end'
  const isPlace = trip && (trip[direction+'_place_token']||trip[direction+'_place'])
  return {
    ...ownProps,
    places: Object.values(state.models.places.byId) || [],
    isPlace,
    // defaultValue: place?place.name : (to||from)
  }
}


const parseAddressComponents = (results) => {
    // https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform
    var adrComps = {
            street_number: 'short_name',
            route: 'long_name',
            locality: 'long_name',
            administrative_area_level_1: 'short_name',
            country: 'long_name',
            postal_code: 'short_name'
          };

    // Get each component of the address from the place details
    // and fill the corresponding field on the form.
    const adrData = {}
    for (var i = 0; i < results[0].address_components.length; i++) {
      var addressType = results[0].address_components[i].types[0];
      if (adrComps[addressType]) {
        var val = results[0].address_components[i][adrComps[addressType]];
        adrData[addressType] = val
      }
    }

    return {
      street: (adrData.street_number || adrData.route) ?`${adrData.street_number} ${adrData.route}`:null,
      // sublocality:
      city: adrData.locality,
      state: adrData.administrative_area_level_1,
      postal_code: adrData.postal_code,
      country: adrData.country,
    }

}




const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getCurrentPosition: ()=>dispatch(getCurrentPosition(ownProps.to ? 'destination': 'origin')),
    // TODO move to container
    onSelect: (value, option)=> {
      const selected = option.props.data

      if (selected.custom) {

        const {from, to} = ownProps
        Object.keys({
          street: null,
          // sublocality:
          city: null,
          state: null,
          postal_code: null,
          country: null,
        }).forEach( key =>
          dispatch(change('trip', `${from?'from':'to'}_${key}`, null))
        )

        // const origin = results[0].geometry.location.toJSON()
        dispatch({
          type:`SELECT_CUSTOM_${from?'FROM':'TO'}`,
          value,
          // from: selected.description,
          // origin,
          // results,
          // center: origin,
          // formatted_address: results[0].formatted_address
        })
        dispatch(change('trip', `${from?'from':'to'}`, value))
        dispatch(change('trip', `${from?'start':'end'}_place_token`, null))
        dispatch(change('trip', `${from?'start':'end'}_place`, null))
        dispatch(change('trip', 'locations', []))
        dispatch({type:'CLEAR_DIRECTIONS'})
        dispatch({type:'CLEAR_MAP'})
        dispatch(change('trip', 'calculate_route_enabled', false))
        dispatch(change('trip', 'round_trip_enabled', false))

        // dispatch(requestDirections())

        return //NEEDED to skip other cases

      }

      if (ownProps.to) {
        if (selected.description) { // google response
          var geocoder = new ownProps.google.maps.Geocoder
          geocoder.geocode({'placeId': selected.place_id}, function(results, status) {
            if (status === 'OK') {
              if (results[0]) {

                const data = parseAddressComponents(results)
                // loop and update all the redux form values
                Object.keys(data).forEach( key =>
                  dispatch(change('trip', `to_${key}`, data[key]))
                )


                const destination = results[0].geometry.location.toJSON()
                dispatch({
                  type:'SELECT_TO',
                  value,
                  // start_place_token: selected.token_id,
                  to: selected.description,
                  destination,
                  results,
                  center: destination,
                  formatted_address: results[0].formatted_address
                })
                // TODO check for round_trip_enabled state here? or in action?
                dispatch(change('trip', 'to', selected.description))
                dispatch(change('trip', 'end_place_token', null))
                dispatch(change('trip', 'end_place', null))
                dispatch(change('trip', 'calculate_route_enabled', true))
                dispatch(requestDirections())

              }
            }
          })


        }

        if (selected.token_id) { // place
          const destination = {lat: selected.latitude, lng: selected.longitude}
          dispatch({
            type:'SELECT_TO',
            value,
            end_place_token: selected.token_id,
            to: `${selected.street} ${selected.city} ${selected.state}`,
            destination
          })
          dispatch(change('trip', 'end_place_token', selected.token_id))
          dispatch(change('trip', 'end_place', selected))
          dispatch(change('trip', 'to', `${selected.street} ${selected.city} ${selected.state}`))
          // dispatch(change('trip', 'ended_at_coordinate', destination.lat+','+destination.lng))
          dispatch(change('trip', 'calculate_route_enabled', true))
          dispatch(requestDirections())

        }
      }


      if (ownProps.from && selected.description) { // google response
        if (selected.description) {
          // new google.maps.LatLng(this.props.center)
          var geocoder = new ownProps.google.maps.Geocoder
          geocoder.geocode({'placeId': selected.place_id}, function(results, status) {
            if (status === 'OK') {
              if (results[0]) {

                const data = parseAddressComponents(results)
                // loop and update all the redux form values
                Object.keys(data).forEach( key =>
                  dispatch(change('trip', `from_${key}`, data[key]))
                )

                const origin = results[0].geometry.location.toJSON()
                dispatch({
                  type:'SELECT_FROM',
                  value,
                  // start_place_token: selected.token_id,
                  from: selected.description,
                  origin,
                  results,
                  center: origin,
                  formatted_address: results[0].formatted_address
                })
                dispatch(change('trip', 'from', selected.description))
                dispatch(change('trip', 'start_place_token', null))
                dispatch(change('trip', 'start_place', null))
                dispatch(change('trip', 'calculate_route_enabled', true))
                dispatch(requestDirections())
              }
            }
          })


        }

      }

      if (ownProps.from && selected.token_id) { // place
        const origin = {lat: selected.latitude, lng: selected.longitude}
        dispatch({
          type:'SELECT_FROM',
          value,
          start_place_token: selected.token_id,
          from: `${selected.street} ${selected.city} ${selected.state}`,
          origin
        })
        dispatch(change('trip', 'start_place_token', selected.token_id))
        dispatch(change('trip', 'start_place', selected))
        dispatch(change('trip', 'from', `${selected.street} ${selected.city} ${selected.state}`))
        // dispatch(change('trip', 'started_at_coordinate', origin.lat+','+origin.lng))
        dispatch(change('trip', 'calculate_route_enabled', true))
        dispatch(requestDirections())

      }

    }
  }
}

// export default connect(mapStateToProps, mapDispatchToProps)(Complete)
export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY
})(
  connect(mapStateToProps, mapDispatchToProps)(Complete)
)



// WEBPACK FOOTER //
// ./src/map/AutoComplete.js